import { Icon } from '@gitbook/spine-icons';
import { DialogRoot, DialogTrigger, Heading } from '@gitbook/spine-react';

import { useNavigation } from '../../../navigation';
import { apiClient } from '../../../state';
import { ImportContentDialog } from '../../Imports';
import { SiteQuickActionCard, SiteQuickActionCardIcon } from '../../Site';
import type { SpaceCreationOnCreateSpace } from './types';

interface ImportCardProps {
    organizationId: string;
    onCreateSpace: SpaceCreationOnCreateSpace;
}

export function ImportCard(props: ImportCardProps) {
    const { organizationId, onCreateSpace } = props;
    const { navigate } = useNavigation();
    return (
        <DialogRoot>
            <DialogTrigger>
                <SiteQuickActionCard>
                    <SiteQuickActionCardIcon>
                        <Icon.Download />
                    </SiteQuickActionCardIcon>
                    <Heading>Import from…</Heading>
                </SiteQuickActionCard>
            </DialogTrigger>
            <ImportContentDialog
                trigger="space_creation"
                target={{ organization: organizationId }}
                onComplete={(target) => {
                    onCreateSpace(
                        async ({ collectionId }) => {
                            if (collectionId !== target.space.parent) {
                                const result = await apiClient.spaces.moveSpace(target.space.id, {
                                    parent: collectionId,
                                });
                                return result.data;
                            }
                            return target.space;
                        },
                        (space) => {
                            navigate({
                                screen: {
                                    type: 'space',
                                    space: space.id,
                                    organization: space.organization,
                                    page: '',
                                    changeRequest: target.changeRequestId,
                                },
                            });
                        }
                    );
                }}
            />
        </DialogRoot>
    );
}
